import React, { useEffect, useState } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import CloseIcon from 'ui-kit/icons/close-icon/close-icon';
import Link, { LinkGroup } from 'ui-kit/link/link';
import MobileToggle from 'ui-kit/mobile-toggle/mobile-toggle';

import logo from 'assets/images/logo.jpg';

import './style.css';

const MobileMenu = () => {
    const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);

    useEffect(() => {
        if (isMobileMenuVisible && document) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isMobileMenuVisible]);

    return (
        <Container
            fluid="md"
            className={`mobile-menu justify-content-center ${isMobileMenuVisible ? 'menu-open' : 'menu-closed'}`}
        >
            <Row className="w-100">
                <Col xs={8} sm={8} md={8} lg={8} className="d-flex justif-content-start">
                    <Link
                        className="site-home-link"
                        to="/"
                        img={<img src={logo} alt="Muncie Land Bank" className="logo" />}
                        label="Muncie Land Bank"
                    />
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} className="d-flex justify-content-end align-items-center">
                    <MobileToggle onClick={() => setIsMobileMenuVisible(true)} />
                </Col>
            </Row>
            <Container className="menu justify-content-start">
                <Row className="menu-header w-100">
                    <Col className="d-flex w-100 justify-content-between align-items-center">
                        <Link
                            className="site-home-link"
                            to="/"
                            img={<img src={logo} alt="Muncie Land Bank" className="logo" />}
                            label="Muncie Land Bank"
                            onClick={() => setIsMobileMenuVisible(false)}
                        />
                        <CloseIcon onClick={() => setIsMobileMenuVisible(false)} variant="light" />
                    </Col>
                </Row>
                <Row className="w-100">
                    <Col className="d-flex w-100 justify-content-center align-items-center">
                        <div className="menu-links">
                            <LinkGroup label="About" onClick={() => setIsMobileMenuVisible(false)}>
                                <Link to="/about/board-of-directors" label="Board of Directors" variant="nav-mobile" />
                                <Link to="/about/board-meetings" label="Board Meetings" variant="nav-mobile" />
                                <Link
                                    to="/about/policy-and-procedures"
                                    label="Policy &amp; Procedures"
                                    variant="nav-mobile"
                                />
                                <Link to="/about/history" label="History" variant="nav-mobile" />
                            </LinkGroup>
                            <LinkGroup label="Resources" onClick={() => setIsMobileMenuVisible(false)}>
                                <Link to="/resources/building-blocks" label="Building Blocks" variant="nav-mobile" />
                                <Link to="/resources/press-releases" label="Press Releases" variant="nav-mobile" />
                                <Link to="/resources/reports" label="Reports" variant="nav-mobile" />
                            </LinkGroup>
                            <Link
                                to="/properties"
                                label="Properties"
                                variant="nav-button"
                                onClick={() => setIsMobileMenuVisible(false)}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default MobileMenu;
